<template>

  <div class="menu-title">
    <p>Tempura Dish</p>
  </div>


  <div class="tempura-container-1">

    <div class="tempura-grid-1">
      <div>
        <img class="menu-pic" src="../assets/TempuraCombo.jpg">
      </div>
      <div class="menu-text">
        <p>Shrimp/Veggie Combo</p> 
        <p>(5/10)</p>
        <!-- <p>13.99</p> -->
      </div>
    </div>

    <div class="tempura-grid-2">
      <div>
        <img class="menu-pic" src="../assets/TempuraShrimp.jpg">
      </div>
      <div class="menu-text">
        <p>Shrimp Tempura (5)</p>
        <!-- <p>9.99</p> -->
      </div>
    </div>

    <div class="tempura-grid-3">
      <div>
        <img class="menu-pic" src="../assets/TempuraSquid.jpg">
      </div>
      <div class="menu-text">
        <p>Squid Tempura</p>
        <!-- <p>11.99 (10)</p> -->
      </div>
    </div>

  </div>


  <div class="tempura-container-2">

    <div class="tempura-grid-4">
      <div>
        <img class="menu-pic" src="../assets/TempuraVeggie.jpg">
      </div>
      <div class="menu-text">
        <p>Veggie Tempura (10)</p>
        <!-- <p>5.99</p> -->
      </div>
    </div>
   
  </div>


</template>


<script>

  export default {
    name: 'TempuraBody'
  }

</script>



<style scoped>

/* for desktop */
@media (min-width:701px) {

  .menu-title {
    text-align: center;
    font-size: 3vw;
    font-weight: bold;
    line-height: 0.5vw;
    margin-bottom: 5vw;
    color: darkblue;
  }


  .tempura-container-1, .tempura-container-2 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    height: 28vw;
    margin-top: 0.5vw;
    background-color: rgb(250,250,250);
  }    
  
  .menu-pic {
    width: 22vw;
    height: 18vw;
    margin-top: 1vw;
    margin-left: 1.5vw;
  }

  .menu-text {
    text-align: center;
    color: darkblue;
    font-style: optima;
    font-size: 2vw;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: -0.5vw;
  }

}


/* for Phone */
@media (max-width:700px) {

  .menu-title {
    text-align: center;
    font-size: 5vw;
    font-weight: bold;
    line-height: 2vw;
    margin-top: -1vw;
    color: darkblue;
  }


  .menu-pic {
    width: 15rem;
    height: auto;
    margin-top: 4vw;
  }
  
  .menu-text {
    text-align: center;
    color: darkblue;
    font-style: optima;
    font-size: 1.2rem;
    font-weight: bold;
    line-height: 0.3rem;
    margin-top: -0.5vw;
  }

}
  
</style>